import IconCheckmarkRoundedFilled from '@repo/monochrome-icons/icon-checkmark-rounded-filled';
import IconCheckmarkRoundedFilledSmall from '@repo/monochrome-icons/icon-checkmark-rounded-filled-small';
import IconClockFilled from '@repo/monochrome-icons/icon-clock-filled';
import IconClockFilledSmall from '@repo/monochrome-icons/icon-clock-filled-small';
import IconCrossRoundedFilled from '@repo/monochrome-icons/icon-cross-rounded-filled';
import IconCrossRoundedFilledSmall from '@repo/monochrome-icons/icon-cross-rounded-filled-small';
import IconMinusRoundedFilled from '@repo/monochrome-icons/icon-minus-rounded-filled';
import IconMinusRoundedFilledSmall from '@repo/monochrome-icons/icon-minus-rounded-filled-small';
import IconPauseRoundedFilled from '@repo/monochrome-icons/icon-pause-rounded-filled';
import IconPauseRoundedFilledSmall from '@repo/monochrome-icons/icon-pause-rounded-filled-small';
import IconPredictedRoundedFilled from '@repo/monochrome-icons/icon-predicted-rounded-filled';
import IconPredictedRoundedFilledSmall from '@repo/monochrome-icons/icon-predicted-rounded-filled-small';
import IconProcessingFilled from '@repo/monochrome-icons/icon-processing-filled';
import IconProcessingFilledSmall from '@repo/monochrome-icons/icon-processing-filled-small';
import IconWarningRoundedFilled from '@repo/monochrome-icons/icon-warning-rounded-filled';
import IconWarningRoundedFilledSmall from '@repo/monochrome-icons/icon-warning-rounded-filled-small';
import type { ComponentType, SVGProps } from 'react';
import type { StatusIconSize, StatusIconStatus } from './types';

export const STATUS_ICON_STATUSES = [
  'approved',
  'cancelled',
  'error',
  'paused',
  'pending',
  'predicted',
  'processing',
  'scheduled',
  'warning',
] as const;

export const STATUS_ICON_SIZES = ['12', '16', '20'] as const;

/**
 * Sizes that use the compact ("Small") icon variant.
 * Small icons have denser, solid-filled paths optimised for tight containers.
 */
export const SMALL_VARIANT_SIZES = new Set<StatusIconSize>(['12']);

type IconPair = {
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
  IconSmall: ComponentType<SVGProps<SVGSVGElement>>;
};
type StatusConfig = IconPair & { color: string };

export const STATUS_ICON_CONFIG = {
  approved: {
    Icon: IconCheckmarkRoundedFilled,
    IconSmall: IconCheckmarkRoundedFilledSmall,
    color: 'var(--content-success)',
  },
  cancelled: {
    Icon: IconMinusRoundedFilled,
    IconSmall: IconMinusRoundedFilledSmall,
    color: 'var(--content-error)',
  },
  error: {
    Icon: IconCrossRoundedFilled,
    IconSmall: IconCrossRoundedFilledSmall,
    color: 'var(--content-error)',
  },
  paused: {
    Icon: IconPauseRoundedFilled,
    IconSmall: IconPauseRoundedFilledSmall,
    color: 'var(--content-secondary)',
  },
  pending: {
    Icon: IconClockFilled,
    IconSmall: IconClockFilledSmall,
    color: 'var(--content-warning)',
  },
  predicted: {
    Icon: IconPredictedRoundedFilled,
    IconSmall: IconPredictedRoundedFilledSmall,
    color: 'var(--content-warning)',
  },
  processing: {
    Icon: IconProcessingFilled,
    IconSmall: IconProcessingFilledSmall,
    color: 'var(--content-secondary)',
  },
  scheduled: {
    Icon: IconClockFilled,
    IconSmall: IconClockFilledSmall,
    color: 'var(--content-accent)',
  },
  warning: {
    Icon: IconWarningRoundedFilled,
    IconSmall: IconWarningRoundedFilledSmall,
    color: 'var(--content-warning)',
  },
} as const satisfies Record<StatusIconStatus, StatusConfig>;
